import type { SVGProps } from "react";
export interface CloudWeatherRain02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CloudWeatherRain02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CloudWeatherRain02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 10a2.88 2.88 0 0 0-2.158-2.785 1.125 1.125 0 0 1-.843-1.135l.001-.08a1.875 1.875 0 0 0-3.003-1.498 1.125 1.125 0 0 1-1.538-.173 3.375 3.375 0 0 0-5.918 2.704c.084.532-.22 1.05-.727 1.234a2.377 2.377 0 0 0 .81 4.608h.526l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H6.5a4.625 4.625 0 0 1-2.375-8.593V6.5a5.625 5.625 0 0 1 9.256-4.295 4.12 4.12 0 0 1 5.68 3.101 5.126 5.126 0 0 1-1.798 9.812l-.264.007h-.357a1.125 1.125 0 0 1 0-2.25H17l.294-.015A2.876 2.876 0 0 0 19.875 10"
      />
      <path
        fill={color}
        d="M6.961 20.367a1.126 1.126 0 0 1 2.078.865l-.5 1.2a1.125 1.125 0 1 1-2.077-.864zm8.5 0a1.125 1.125 0 0 1 2.078.865l-.5 1.2a1.125 1.125 0 0 1-2.078-.864zm-2.454 1.136a1.126 1.126 0 0 1-2.013-1.006zm-2.013-9.005a1.125 1.125 0 0 1 2.013 1.004l-1.187 2.373H14a1.124 1.124 0 0 1 1.006 1.628l-2 4L12.002 21l-1.007-.503 1.185-2.372H10a1.126 1.126 0 0 1-1.006-1.628zM5.29 19.133a1.125 1.125 0 0 1-2.078-.865zm15 0a1.125 1.125 0 0 1-2.078-.865zM3.71 17.068a1.125 1.125 0 1 1 2.077.864l-.5 1.201L4.25 18.7l-1.039-.432.5-1.2Zm15 0a1.125 1.125 0 1 1 2.077.864l-.5 1.201-1.038-.433-1.039-.432z"
      />
    </svg>
  );
}
